import React from "react";
import PropTypes from "prop-types";

export const StaticVirtualTagRow = ({ row }) => {
    const rowProps = row.getRowProps();
    const { key, ...otherRowProps } = rowProps;
    
    return (
        <div key={key} {...otherRowProps} className="tr rounded-[11px] bg-card border border-card-bd shadow-lg cursor-grabbing">
            {row.cells.map((cell, cellIndex) => {
                const { key, ...cellProps } = cell.getCellProps();
                const centered = cell.column.align === "center";
                return (
                    <div
                        key={key}
                        {...cellProps}
                        className={`td flex items-center py-2.5 text-sm ${
                            centered ? 'justify-center' : cellIndex === 0 ? 'pl-5' : 'pl-2'
                        }`}
                    >
                        {cellIndex === 0 ? (
                            <div className="flex items-center min-w-0">
                                <div className="cursor-grab mr-2 shrink-0 text-text-3 hover:text-text">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                                        <circle cx="2" cy="2" r="1"/>
                                        <circle cx="6" cy="2" r="1"/>
                                        <circle cx="10" cy="2" r="1"/>
                                        <circle cx="2" cy="6" r="1"/>
                                        <circle cx="6" cy="6" r="1"/>
                                        <circle cx="10" cy="6" r="1"/>
                                        <circle cx="2" cy="10" r="1"/>
                                        <circle cx="6" cy="10" r="1"/>
                                        <circle cx="10" cy="10" r="1"/>
                                    </svg>
                                </div>
                                {cell.render("Cell")}
                            </div>
                        ) : (
                            cell.render("Cell")
                        )}
                    </div>
                );
            })}
        </div>
    );
};

StaticVirtualTagRow.propTypes = {
    row: PropTypes.object.isRequired,
};
